
import { Download, Features, SectionWrapper } from './components';
import assets from './assets';
import styles from './styles/Global';

const App = () => {
  return (
    <>
      <SectionWrapper 
        title='Your Savior'
        description="You Are Your Own Savior!
         Application for helping victims facing brutality from society in many ways."
        showBtn
        mockupImg={assets.homeHero}
        banner="banner"
      />
      <SectionWrapper 
        title="Simple user friendly interface"
        description="Best UI experience with multipurpose functionality like News updates, alert messaging system and crime reporting functionalities and many more features."
        mockupImg={assets.homeCards}
        reverse
      />
      <Features />
      <SectionWrapper 
        title="Deployment"
        description="Your Savior is built using Expo which runs natively on all users' devices. You can easily get your app into people's hands"
        mockupImg={assets.feature}
        reverse
      />
      <SectionWrapper 
        title="Innovative way to build a platform for Society"
        description="The app contains two main screens. The first screen has Alert messaging systems for generating alert sms with attached current location, Second one is feeds screen where you can get updated news about specific crimes and you can also report cases."
        mockupImg={assets.mockup}
        banner="banner02"
      />
      <Download />

      <div className="px-4 py-2 justify-center items-center bg-primary flex-col text-center banner04">
        <p className={`${styles.pText} ${styles.whiteText}`}>&#169; Copyright 2022  {" "}
        <span className="bold">Your Savior</span>
        </p>
      </div>
    </>
  );
}

export default App;
